import axios from "axios";
import { verifiedGTNBaseUrl } from "../../constants";

export const fetchAllNSDQAssets = async (page) => {
  return await axios({
    method: "GET",
    url: page
      ? `${verifiedGTNBaseUrl}/nsdq?rows=200&page=${page}`
      : `${verifiedGTNBaseUrl}/nsdq?rows=200`,
  })
    .then((res) => {
      return res.data?.body?.data?.response;
    })
    .catch((err) => {
      console.error(
        "Error while fetching all GTN NSDQ assests :",
        err?.message,
      );
      return {};
    });
};

export const fetchTickerDetails = async (ticker) => {
  return await axios({
    method: "GET",
    url: `${verifiedGTNBaseUrl}/ticker?ticker=${ticker}`,
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return {
          price: "0",
          shortName: "",
          sourceId: "",
          tickerId: "",
          priceCurrencyId: "",
        };
      }
    })
    .catch((err) => {
      console.error("Error while fetching all ticker details :", err?.message);
      return {
        price: "0",
        shortName: "",
        sourceId: "",
        tickerId: "",
        priceCurrencyId: "",
      };
    });
};

export const fetchCustomerDetails = async (customerNumber) => {
  return await axios({
    method: "GET",
    url: `${verifiedGTNBaseUrl}/customer?customerNumber=${customerNumber}`,
  })
    .then((res) => {
      if (res.data?.body?.data?.cashAccounts) {
        return res.data?.body?.data?.cashAccounts;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.error("Error while fetching customer details :", err?.message);
      return [];
    });
};

export const createNewCustomer = async (firstName, lastName, email) => {
  return await axios({
    method: "POST",
    url: `${verifiedGTNBaseUrl}/customer`,
    data: {
      firstName,
      lastName,
      email,
    },
  })
    .then((res) => {
      if (res.data?.body?.data?.customerNumber) {
        return res.data?.body?.data?.customerNumber;
      } else {
        return "";
      }
    })
    .catch((err) => {
      console.error("Error while creating new customer :", err?.message);
      return "";
    });
};

export const fetchTickeChartData = async (ticker, sourceId, page) => {
  return await axios({
    method: "GET",
    url: page
      ? `${verifiedGTNBaseUrl}/ticker-chart-history?ticker=${ticker}&sourceId=${sourceId}&rows=200&page=${page}`
      : `${verifiedGTNBaseUrl}/ticker-chart-history?ticker=${ticker}&sourceId=${sourceId}&rows=200`,
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return {
          priceCandles: [],
          volumeCandles: [],
          price: [],
          volume: [],
        };
      }
    })
    .catch((err) => {
      console.error(
        "Error while fetching all ticker chart data :",
        err?.message,
      );
      return {
        priceCandles: [],
        volumeCandles: [],
        price: [],
        volume: [],
      };
    });
};

export const createOrder = async (
  customerNumber,
  securityAccount,
  tickerSymbol,
  sourceId,
  tickerFull,
  amount,
  tradeType,
  oppositeOrder,
) => {
  return await axios({
    method: "POST",
    url: `${verifiedGTNBaseUrl}/create-order`,
    data: {
      customerNumber,
      securityAccount,
      tickerSymbol,
      sourceId,
      tickerFull,
      amount,
      orderSide: tradeType?.toLowerCase() === "buy" ? 1 : 2,
      tif: "1",
      oppositeOrder: {
        orderAmount: oppositeOrder?.orderAmount,
        orderId: "",
        userData: oppositeOrder?.userData,
        poolId: oppositeOrder?.poolId,
        tokenIn: oppositeOrder?.tokenIn,
        tokenOut: oppositeOrder?.tokenOut,
        tokensList: oppositeOrder?.tokensList,
        orderOffchainId: "",
        chainId: oppositeOrder?.chainId,
      },
    },
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.error(
        "Error while fetching all ticker chart data :",
        err?.message,
      );
      return null;
    });
};

export const getOrders = async (
  customerNumber,
  securityAccount,
  cashAccountNumber,
  page,
) => {
  return await axios({
    method: "GET",
    url: `${verifiedGTNBaseUrl}/orders?custmerNumber=${customerNumber}&securityAccount=${securityAccount}&cashAccountNumber=${cashAccountNumber}&pageWidth=200&pageNo=${page}`,
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.error("Error while fetching all orders :", err?.message);
      return null;
    });
};

export const getOrderDetails = async (orderId) => {
  return await axios({
    method: "GET",
    url: `${verifiedGTNBaseUrl}/orders-details?orderId=${orderId}`,
  })
    .then((res) => {
      if (res.data?.body?.data) {
        return res.data?.body?.data;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.error("Error while fetching order details:", err?.message);
      return null;
    });
};

export const getTickerCoporateActions = async (ticker) => {
  return await axios({
    method: "GET",
    url: `${verifiedGTNBaseUrl}/ticker-coporate?keys=${ticker}`,
  })
    .then((res) => {
      if (res.data?.body?.data?.response?.docs) {
        return res.data?.body?.data?.response?.docs;
      } else {
        return [];
      }
    })
    .catch((err) => {
      console.error("Error while fetching ticker coporate:", err?.message);
      return null;
    });
};
